import { render } from "./Astra.vue?vue&type=template&id=4eb38feb&scoped=true"
import script from "./Astra.vue?vue&type=script&lang=js"
export * from "./Astra.vue?vue&type=script&lang=js"

import "./Astra.vue?vue&type=style&index=0&id=4eb38feb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb38feb"]])

export default __exports__